import { Component } from '@angular/core';

@Component({
  selector: 'cc-embed-library-apps',
  templateUrl: 'embed-library-apps.component.html',
  styleUrls: ['embed-library-apps.component.scss'],
})
export class EmbedLibraryAppsComponent {
  openLargeVersion() {
    const url = window.location.href.replace('embed/', '');
    window.open(url);
  }
}
